import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { Router } from "@angular/router";
import { AuthService } from "src/app/services/auth.service";

@Injectable()
export class AuthGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    void state;
    const isLoggedIn = this.authService.isLoggedIn();
    const trial = JSON.parse(localStorage.getItem("trial"));
    if (isLoggedIn && !trial) {
      return true;
    }
    if (isLoggedIn && trial) {
      // Trial users can only access downloads area
      // "" is shell
      if (next.routeConfig.path == "" || next.routeConfig.path == "downloads") return true;
    }
    return this.router.parseUrl("/login");
  }
}
